module.exports = __webpack_public_path__ + "img/googleplay.b92bf039.png";